export function filterPhotosForTeam(teamPhotos, teamId) {
  if (!Array.isArray(teamPhotos) || teamId == null) return []
  return teamPhotos.filter(p => p.team_id === teamId)
}
